export const PARTNERS_GET_ALL_REQUEST = 'PARTNERS_GET_ALL_REQUEST';
export const PARTNERS_GET_ALL_SUCCESS = 'PARTNERS_GET_ALL_SUCCESS';
export const PARTNERS_GET_ALL_ERROR = 'PARTNERS_GET_ALL_ERROR';

export const PARTNERS_GET_SINGLE_REQUEST = 'PARTNERS_GET_SINGLE_REQUEST';
export const PARTNERS_GET_SINGLE_SUCCESS = 'PARTNERS_GET_SINGLE_SUCCESS';
export const PARTNERS_GET_SINGLE_ERROR = 'PARTNERS_GET_SINGLE_ERROR';
